<template>
  <div class="">
    <div
      class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-6"
    >
      <offer-grid-item
        class=""
        v-for="(offer, index) in firstTwelveOffers"
        :key="offer.id"
        :guest="guest"
        :offer="offer"
        :lang="lang"
        @show-register-modal="loadRegisterModal"
      ></offer-grid-item>
    </div>

    <offer-grid-featured-offer-full-width
      class="offerGridFeaturedOfferFullWidth"
      :guest="guest"
      :lang="lang"
      :initFeaturedOffer="featuredOffer"
      v-if="showFeaturedOffer"
      @show-register-modal="loadRegisterModal"
    >
    </offer-grid-featured-offer-full-width>
    <div v-else class="mb-6"><!-- SPACER - WHEN NO FEATURES OFFER --></div>

    <div
      class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-6"
    >
      <offer-grid-item
        class=""
        v-for="(offer, index) in secondTwelveOffer"
        :key="offer.id"
        :guest="guest"
        :offer="offer"
        :lang="lang"
        @show-register-modal="loadRegisterModal"
      ></offer-grid-item>
    </div>

    <modal-master-guest ref="modalMasterGuest"></modal-master-guest>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import OfferGridItem from "./OfferGridItem.vue";
import OfferGridFeaturedOfferFullWidth from "./OfferGridFeaturedOfferFullWidth.vue";
import ModalMasterGuest from "../modal/ModalMasterGuest.vue";

// COMPONENT PROPS
const props = defineProps({
  guest: Boolean,
  lang: Object,
  offers: { type: Array, default: null },
  featuredOffers: { type: Array, default: null },
});

// COMPONENT DATA
const featuredOffer = ref(null);
const hasFeaturedOffer = ref(false);
const modalMasterGuest = ref(null);

// METHODS
/**
 * load register modal
 */
const loadRegisterModal = (trigger) => {
  let modalData = {
    modalTrigger: trigger,
  };

  modalMasterGuest.value.loadModal("guestRegister", modalData);
};

/**
 * render featured offers
 */
const setFeaturedOffer = () => {
  if (props.featuredOffers && props.featuredOffers.length > 0) {
    featuredOffer.value = _.head(_.shuffle(props.featuredOffers));
    hasFeaturedOffer.value = true;
  }
};

/**
 * determine if the featured offer should be displayed
 */
const showFeaturedOffer = computed(() => {
  // check if featured offers do exist
  if (props.featuredOffers === null || !props.featuredOffers.length) {
    return false;
  }

  // check if enough offers are provided
  if (props.offers === null || props.offers.length < 12) {
    return false;
  }

  return hasFeaturedOffer.value;
});

const firstTwelveOffers = computed(() => {
  return props.offers ? props.offers.slice(0, 12) : [];
});

const secondTwelveOffer = computed(() => {
  return props.offers ? props.offers.slice(12, 24) : [];
});

// LIFECYCLE EVENTS
onMounted(() => {
  setFeaturedOffer();
});
</script>

